export const environment = {
  production: false,

  firebase: {
    apiKey: "AIzaSyDrSXf96FSDuSPKOTTXfgfL69MwOE0lZXU",
    authDomain: "pulsetrader-af557.firebaseapp.com",
    projectId: "pulsetrader-af557",
    storageBucket: "pulsetrader-af557.firebasestorage.app",
    messagingSenderId: "776982468502",
    appId: "1:776982468502:web:7740432e2b7b96308f2fb7",
    measurementId: "G-KVZE2K8FN3" // optional, nur wenn im Config-Block vorhanden
  },

  // Backend-URL (später für deinen Tower via Tunnel / Oracle VM)
  // Für lokal ist FastAPI häufig auf 8000, passt das ggf. später an.
  apiBaseUrl: "http://localhost:8000"
};